<template>
	<div>
		<b-navbar type="dark" variant="dark">
			<b-container>
				<b-navbar-brand :to="'/' + this.$i18n.locale">
					<img class="logo" alt="Stay.com" src="../../assets/logo.svg">
				</b-navbar-brand>
				<b-navbar-nav class="ml-auto">
					<b-nav-item-dropdown v-b-tooltip.hover :title="$t('Need travel inspiration?')"  :text="$t('Magazine')" class="d-none d-md-block ml-1" right>
						<template slot="button-content">
							<font-awesome-icon :icon="['fas', 'map-marker-alt']" class="mr-1" size="lg" />
							{{ $t('Magazine') }}
						</template>
						<b-dropdown-item :href="'/' + $i18n.locale + '/destination/africa'">
							<img src="~@/assets/continents/1.svg" width="25" class="mr-2" />
							{{ $t('Africa') }}
						</b-dropdown-item>
						<b-dropdown-item :href="'/' + $i18n.locale + '/destination/antarctica'">
							<img src="~@/assets/continents/7.svg" width="25" class="mr-2" />
							{{ $t('Antarctica') }}
						</b-dropdown-item>
						<b-dropdown-item :href="'/' + $i18n.locale + '/destination/asia'">
							<img src="~@/assets/continents/2.svg" width="25" class="mr-2" />
							{{ $t('Asia') }}
						</b-dropdown-item>
						<b-dropdown-item :href="'/' + $i18n.locale + '/destination/oceania'">
							<img src="~@/assets/continents/3.svg" width="25" class="mr-2" />
							{{ $t('Australia/Oceania') }}
						</b-dropdown-item>
						<b-dropdown-item :href="'/' + $i18n.locale + '/destination/europe'">
							<img src="~@/assets/continents/4.svg" width="25" class="mr-2" />
							{{ $t('Europe') }}
						</b-dropdown-item>
						<b-dropdown-item :href="'/' + $i18n.locale + '/destination/north-america'">
							<img src="~@/assets/continents/5.svg" width="25" class="mr-2" />
							{{ $t('North-America') }}
						</b-dropdown-item>
						<b-dropdown-item :href="'/' + $i18n.locale + '/destination/south-america'">
							<img src="~@/assets/continents/6.svg" width="25" class="mr-2" />
							{{ $t('South-America') }}
						</b-dropdown-item>
					</b-nav-item-dropdown>
					
					<b-nav-item-dropdown v-b-tooltip.hover :title="$t('Choose currency')" class="nav-dropdown ml-1" right>
						<template slot="button-content">
							{{ selectedCurrency.iso }}
						</template>
						<b-dropdown-item @click="setCurrency(currency.iso)" v-for="(currency, i) in currencies" :key="`Currency${i}`">
							{{ currency.iso }} - <small>{{ currency.name }}</small>
						</b-dropdown-item>
					</b-nav-item-dropdown>

					<b-nav-item-dropdown v-b-tooltip.hover :title="$t('Choose language')" class="nav-dropdown ml-1" right>
						<template slot="button-content">
							<img :src="`/flags/` + selectedLang.iso + `.svg`" width="25" class="mr-2" />
						</template>
						<b-dropdown-item @click="setLocale(lang.locale)" v-for="(lang, i) in langs" :key="`Lang${i}`">
							<img :src="`/flags/` + lang.iso + `.svg`" width="25" class="mr-2" />
							{{ lang.name }}
						</b-dropdown-item>
					</b-nav-item-dropdown>

					<b-nav-item v-b-tooltip.hover :title="$t('Contact customer service')" class="d-none d-md-block ml-1">
						<b-icon icon="question-circle" aria-hidden="true"></b-icon>
					</b-nav-item>

					<!--
					<b-nav-item-dropdown text="User" right>
						<b-dropdown-item href="#">Account</b-dropdown-item>
						<b-dropdown-item href="#">Settings</b-dropdown-item>
					</b-nav-item-dropdown>
					-->
				</b-navbar-nav>
			</b-container>
		</b-navbar>
	</div>
</template>

<script>
//import Vue from 'vue'

import { library } from '@fortawesome/fontawesome-svg-core'

import { 
	faMapMarkerAlt, 
} from '@fortawesome/free-solid-svg-icons'

library.add(faMapMarkerAlt)

export default {
	name: 'Navbar',
	data () {
		return {
			currencies: {
				'EUR': {
					iso: 'EUR',
					name: 'Euro',
					icon: '€'
				},
				'GBP': {
					iso: 'GBP',
					name: 'Pound sterling',
					icon: '£'
				},
				'USD': {
					iso: 'USD',
					name: 'U.S. Dollar',
					icon: '$'
				},
				'AUD': {
					iso: 'AUD',
					name: 'Australian Dollar',
					icon: '$'
				},
				'CAD': {
					iso: 'CAD',
					name: 'Canadian Dollar',
					icon: '$'
				}
			},
			langs: {
				'de-de': {
					locale: 'de-de',
					iso: 'de',
					name: 'Deutsch'
				},
				'en-us': {
					locale: 'en-us',
					iso: 'us',
					name: 'English (US)'
				},
				'en-gb': {
					locale: 'en-gb',
					iso: 'gb',
					name: 'English (UK)'
				},
				'nl-nl': {
					locale: 'nl-nl',
					iso: 'nl',
					name: 'Nederlands'
				},
			},
			selectedLang: null,
			selectedCurrency: null,
		}
	},
	methods: {
		setLocale(locale) {
			/*
			Vue.config.lang = locale
			this.$i18n.locale = Vue.config.lang
			this.selectedLang = this.langs[locale];
			*/

			let uri = this.$route.fullPath;
			uri = uri.replace(this.$route.params.locale, locale);

			window.location = uri;

			//this.$router.push({
			//	path: uri
			//})
		},
		setCurrency(iso) {
			let cur = this.currencies[iso];
			this.selectedCurrency = cur;

			this.$router.replace({path: this.$route.path, query: { ...this.$route.query, currency: iso }})
			window.location = this.$route.fullPath;
		}
	},
	created() {
		let lang = this.langs[this.$i18n.locale];
		this.selectedLang = lang;

		let currency = (this.$route.query.currency ? this.$route.query.currency : 'EUR');
		let cur = this.currencies[currency];
		this.selectedCurrency = cur;
	}
}
</script>

<style scoped>
	.logo{
		width:150px;
	}
	.navbar{
		background-color:#0040C1 !important;
	}
	.navbar-dark .navbar-nav .nav-link{
		color:rgba(255, 255, 255, 0.8) !important;
	}
	.navbar-dark .navbar-nav .nav-link:hover{
		color:rgba(255, 255, 255, 1) !important;
	}
</style>